import useApi from "./useApi";
import Product from "../interfaces/product";
import { useMutation, useQueryClient } from "@tanstack/react-query";

const useRegisterProduct = () => {
    const { register } = useApi<Product>("/products");
    const query = useQueryClient();

    return useMutation({
        mutationFn: (product: Product) => register(product),
        onSuccess: () => {
            query.invalidateQueries({queryKey: ["products"]});
        }
    })
};

export default useRegisterProduct;